/**
 * 키값으로 객체를 그룹화
 * @param {*} array
 * @param {*} key
 * @param {*} name 생략시, 그룹화된 객체의 키값으로 배열이 반환됨
 * @returns
 */

export default function groupBy(array, key, name) {
  return array.reduce((acc, cur) => {
    // console.log('acc', acc, cur)
    if (!acc[cur[key]]) acc[cur[key]] = name ? { [name]: cur[name], [key]: cur[key], data: [cur] } : [cur]
    else if (name) {
      acc[cur[key]].data.push(cur)
    } else {
      acc[cur[key]].push(cur)
    }
    return acc
  }, {})
}
